import React from 'react';
import { MdAdd, MdRemove } from 'react-icons/md';

import { Input } from '../../shadcn/Input';
import { Button } from '../../shadcn/Button';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

interface Props {
  disableManualEntry?: boolean;
  isDisabled?: boolean;
  max?: number;
  quantity: number;
  setQuantity: (arg: number) => void;
}

const QuantityCounter = ({
  disableManualEntry = false,
  isDisabled = false,
  max = null,
  quantity,
  setQuantity,
}: Props) => {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <div className="flex items-center justify-between p-2 gap-1 w-min rounded-interface border border-border">
      <Button
        aria-label={tt(s => s.quantityCounterComponent.decreaseQuantityAlt)}
        className="h-8 w-8 !rounded-interface"
        disabled={quantity <= 1 || isDisabled}
        onClick={() => quantity > 1 && setQuantity(quantity - 1)}
        size="icon"
      >
        <MdRemove size="24px" />
      </Button>
      <Input
        aria-label={tt(s => s.quantityCounterComponent.quantityAlt)}
        className="text-center h-6 w-6 p-0 border-none"
        name="quantity"
        onChange={e => setQuantity(Number(e.target.value))}
        readOnly={disableManualEntry}
        type="number"
        value={quantity}
      />
      <Button
        aria-label={tt(s => s.quantityCounterComponent.increaseQuantityAlt)}
        className="h-8 w-8 !rounded-interface"
        disabled={(max && quantity === max) || isDisabled || quantity >= 99}
        onClick={() =>
          quantity < max && quantity < 99 && setQuantity(quantity + 1)
        }
        size="icon"
      >
        <MdAdd size="24px" />
      </Button>
    </div>
  );
};

export default QuantityCounter;
